export const ROUTES = {
  STORE_ORDERS: "store/orders",
  POST_LOGIN: "store/postLogin",
  STORE_PAYPAL_TOKEN: "store/paypal/client-token",
};

export const ORDER_STATES = {
  CREATED: "created",
  PAYMENT_PENDING: "payment_pending",
  PAYMENT_SUCCEED: "payment_succeed",
  PAYMENT_FAILED: "payment_failed",
  CHARGE_PENDING: "charge_pending",
  CHARGE_SUCCEED: "charge_succeed",
  CHARGE_FAILED: "charge_failed",
};
